import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar.jsx";
import Footer from "./components/Footer.jsx";
import Home from "./pages/Home.jsx";
import About from "./pages/About.jsx";
import Services from "./pages/Services.jsx";
import Contact from "./pages/Contact.jsx";
import Privacy from "./pages/Privacy.jsx";
import Terms from "./pages/Terms.jsx";

/* Global styles (colours, fonts, reset). Page-specific CSS lives inside each page file. */
const globalCss = `
:root{
  --navy:#183350;
  --navy-deep:#0F2238;
  --navy-soft:#2A4A6F;
  --silver:#B9C2CC;
  --mist:#EEF1F4;
  --paper:#F7F8FA;
  --white:#FFFFFF;
  --ink:#1B2530;
  --muted:#5B6773;
  --gold:#C9A24B;
  --gold-dark:#A9842F;
  --font-head:'Archivo','Segoe UI',Arial,sans-serif;
  --font-body:'Source Sans 3','Segoe UI',Arial,sans-serif;
  --maxw:1180px;
}
*,*::before,*::after{box-sizing:border-box}
html{scroll-behavior:smooth}
body{margin:0;font-family:var(--font-body);font-size:17px;line-height:1.65;color:var(--ink);background:var(--white);-webkit-font-smoothing:antialiased}
h1,h2,h3,h4{font-family:var(--font-head);color:var(--navy);line-height:1.15;margin:0 0 .5em}
p{margin:0 0 1em}
img{max-width:100%;display:block}
a{color:inherit}
.container{width:100%;max-width:var(--maxw);margin:0 auto;padding:0 24px}
.btn{display:inline-block;font-family:var(--font-head);font-weight:600;font-size:15px;padding:14px 28px;border-radius:4px;text-decoration:none;border:2px solid transparent;cursor:pointer;transition:background .2s,color .2s,border-color .2s}
.btn-gold{background:var(--gold);color:var(--navy-deep)}
.btn-gold:hover{background:var(--gold-dark);color:#fff}
.btn-navy{background:var(--navy);color:#fff}
.btn-navy:hover{background:var(--navy-deep)}
.btn-outline{border-color:#fff;color:#fff}
.btn-outline:hover{background:#fff;color:var(--navy)}
:focus-visible{outline:3px solid var(--gold);outline-offset:2px}
@media (prefers-reduced-motion:reduce){html{scroll-behavior:auto}*{transition:none!important;animation:none!important}}
`;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <>
      <style>{globalCss}</style>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
